import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable";
import { format } from '../../../functions/functions';
import NumericFilter from '../../../components/ParadigmaTable/NumericFilter';
import DateFilter from "../../../components/ParadigmaTable/DateFilter";
import moment from 'moment';

class Obras extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Moneda",
                    id: "moneda",
                    accessor: "moneda",
                    show: false,
                    private: true,
                },

                {
                    Header: "Titulo",
                    id: "titulo",
                    accessor: d => d.titulo,
                    show: true,
                },
                {
                    Header: "Loteo",
                    id: "loteo",
                    lookup: "nombre__icontains",
                    accessor: d => d.loteo.nombre,
                    show: true,
                },
                {
                    Header: "Proveedor",
                    id: "proveedor",
                    lookup: "nombre__icontains",
                    accessor: d => d.proveedor.nombre,
                    show: true,
                },
                {
                    Header: "Monto",
                    id: "monto",
                    accessor: d => `${d.moneda.simbolo} ${format(d.monto)}`,
                    className: "monto",
                    show: true,
                    Filter: ({ filter, onChange }) => <NumericFilter filter={filter} onChange={onChange}/>
                },
                {
                    Header: "Fecha Contrato",
                    id: "fechaContrato",
                    accessor: d => d.fechaContrato ? moment(d.fechaContrato).format('DD-MM-YYYY') : '',
                    className: "text-center",
                    show: true,
                    Filter: ({ filter, onChange }) => <DateFilter filter={filter} onChange={onChange} datetime />,
                },
                {
                    Header: "Descripción",
                    id: "descripcion",
                    accessor: d => d.descripcion,
                    show: false,
                },
                {
                    Header: "Archivo Contrato",
                    id: "archivoContratoHash",
                    className:"text-center",
                    accessor: d => d.archivoContratoHash ?
                        <a href={api.obras.contrato.replace('$obra_id', d.id) + '?hash=' + d.archivoContratoHash} target="_blank">DESCARGAR</a> :
                        '-',
                    filterable: false,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'obras_obras_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'obras_obras_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'obras_obras_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'obras_obras_delete',
                    }
                ]}
                depth={2}
                apiUrl={api.obras.obras}
                columns={this.state.columns}
                exportUrl={api.obras.obras}
                title={"Obras"}
            />
        );
    }
}

export default Obras;



// WEBPACK FOOTER //
// ./src/views/Obras/Obras/Obras.js